import { serializeError } from '/utils.js';

/**
 * Append one collect-phase incident (thrown read, blocked API, etc.).
 * This is not proof of “tampering”: the same signals appear for broken proxies,
 * privacy extensions, automation, or browser bugs—we only know the probe failed.
 *
 * @param {Array<object>} incidents
 * @param {{ source: string, phase: string, key?: string, error?: unknown }} incident
 */
export function pushCollectIncident(incidents, incident) {
  const row = { source: incident.source, phase: incident.phase };
  if (incident.key != null && incident.key !== '') row.key = String(incident.key);
  if (incident.error != null) row.error = serializeError(incident.error);
  incidents.push(row);
}
